export default __webpack_public_path__ + "static/section6-b3995e1b46f3cd26bce1b3b7b6b1c7cc.png";